import Component from "@ember/component"
import { computed, get } from "@ember/object"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type Session from "cc-frontend/services/session"
import _ from "lodash"
import { debounce } from "lodash-es"
import styles from "./timeline.module.css"

export default class PerspectiveTimeline extends Component {
  readonly styles = styles

  // args
  courses!: Array<Course>
  instructionalCourses!: Array<Course>
  planbook!: Planbook
  rotationCalendar!: RotationCalendar
  focusedItemId!: string
  canBeEditable!: boolean
  isSelectable!: boolean
  onNewFocusedItemId!: string | null
  hiddenCourseIds!: Array<string> | []

  //services
  session!: Session

  // CPs and getters
  @computed("session.user.meta.permissions.[]", "planbook.meta.permissions")
  get showPaywall() {
    let userPermissions = get(this.session.user, "meta.permissions")
    let planbookPermissions = this.planbook.meta.permissions
    return (
      _.includes(planbookPermissions, "can-edit-plan") &&
      !_.includes(userPermissions, "can-access-unit-planner")
    )
  }

  @computed("instructionalCourses.length", "hiddenCourseIds.length")
  get visibleCourses() {
    return _.reject(this.instructionalCourses, (course) => {
      if (course) {
        return _.includes(this.hiddenCourseIds, course.id)
      } else {
        return undefined
      }
    })
  }

  scrollLeft = debounce(
    () => {
      let scrollPosition = $(".js-timeline-wrapper").scrollLeft()
      if (scrollPosition === undefined) return
      $(".js-timeline-wrapper").animate({ scrollLeft: -200 + scrollPosition, duration: 200 })
    },
    200,
    { leading: true }
  )

  scrollRight = debounce(
    () => {
      let scrollPosition = $(".js-timeline-wrapper").scrollLeft()
      if (scrollPosition === undefined) return
      $(".js-timeline-wrapper").animate({ scrollLeft: 200 + scrollPosition, duration: 200 })
    },
    200,
    { leading: true }
  )
}
